import { Injectable } from '@angular/core';
import { UserProvider } from './user';
import { DatasetProvider, DatasetType } from './dataset';

@Injectable()
export class DatasetNotificationsProvider {
    constructor(private userProvider: UserProvider, private datasetProvider: DatasetProvider) {}

    public shouldShowLowImagesWarning(datasetIdentifier: string): boolean {
        if (!this.userProvider.canManageDatasets()) {
            return false;
        }

        const dataset = this.datasetProvider.getDatasetById(datasetIdentifier);

        let shouldShow = dataset ? dataset.type === DatasetType.SceneRecognition : false;
        if (shouldShow && dataset && Object.keys(dataset.classCounts).length > 0) {
            shouldShow = Object.keys(dataset.classCounts)
                .map(count => dataset.classCounts[count])
                .some(classCount => classCount < 50);
        }

        return shouldShow;
    }
}



// WEBPACK FOOTER //
// ./src/providers/dataset-notifications.ts